import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';
import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { Image } from 'ish-core/models/image/image.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ProductHelper } from 'ish-core/models/product/product.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

@Component({
  selector: 'custom-dot-cms-product-tile',
  templateUrl: './dot-cms-product-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsProductTileComponent implements OnInit {
  readonly layout = input<string>(undefined);
  product$: Observable<ProductView>;
  isMasterProduct = false;
  isPopupVisible = true;
  variationCount$: Observable<number>;
  deviceType$: Observable<DeviceType>;
  constructor(private context: ProductContextFacade, private appFacade: AppFacade) {}

  ngOnInit() {
    this.deviceType$ = this.appFacade.deviceType$;
    this.product$ = this.context.select('product').pipe(
      tap(product => {
        this.isMasterProduct = ProductHelper.isMasterProduct(product);
      })
    );
    this.variationCount$ = this.context.select('variationCount');
  }

  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }

  openQuickView(productSku: string) {
    this.appFacade.openQuickView(productSku);
  }

  getImagesViews(product: ProductView): string[] {
    const images: Image[] = product?.images?.filter(image => image.typeID === 'M');
    const imageViews: string[] = [];

    images?.every((image, index) => {
      if (index > 1) {
        return false;
      }

      if (image.primaryImage) {
        imageViews.unshift(image.viewID);
      } else {
        imageViews.push(image.viewID);
      }

      return true;
    });

    if (!imageViews.length) {
      imageViews.push('');
    }
    if (imageViews.length === 1) {
      imageViews.push(imageViews[0]);
    }
    return imageViews;
  }
}
